<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    :prepend-icon="icon"
    :clearable="true"
    dense
    item-text="name"
    return-object
    hide-selected
    hide-no-data
    autocomplete="off"
    @change="signalChange"
  />
</template>

<script>
export default {
  name: "TagSelect",
  props: {
    icon: {
      type: String,
      default: "mdi-tag",
    },
    label: {
      type: String,
      default: "Tag",
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    items: [],
    loading: false,
    search: null,
  }),
  computed: {
    model: {
      get: function () {
        return this.value
          ? Object.keys(this.value).length
            ? this.value
            : null
          : null;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    model() {
      // Make sure the passed prop is part of items
      this.items.push(this.model);
    },
    search() {
      this.getTags();
    },
  },
  mounted() {
    this.getTags();
  },
  methods: {
    signalChange: function (event) {
      this.$emit("change", event);
    },
    getTags() {
      // Items have already been requested
      if (this.loading) {
        return;
      }

      this.loading = true;

      let filter = {
        page: {
          number: 1,
          size: 30,
        },
        sort: "order",
        filter: {},
      };

      if (this.search) {
        filter.filter.search = this.search;
      }

      this.$models.Tag.all(filter)
        .then((response) => {
          this.items = response.data;
          this.items.push(this.model);
          this.loading = false;
        })
        .catch((error) => {
          this.$bus.$emit("Error", error);
        });
    },
  },
};
</script>
